import {RouteProps} from 'config/navigation';
import Users from 'modules/users/pages/users';
import CreateUser from 'modules/users/pages/create-user';
import DriverDetails from './user-details';
import {FaUser} from 'react-icons/fa';

const usersPages: RouteProps = {
  name: 'Usuários',
  path: 'users',
  permission: 'users.findAll',
  icon: <FaUser />,
  subRoutes: [
    {
      path: '',
      element: <Users />,
      permissions: ['users.findAll'],
    },
    {
      path: 'create',
      element: <CreateUser />,
      permissions: ['users.findOne'],
    },
    {
      path: ':id',
      element: <DriverDetails />,
      permissions: ['users.findOne'],
    },
    {
      path: ':id/system',
      element: <DriverDetails activeTab="system" />,
      permissions: ['users.findOne'],
    },
  ],
};

export default usersPages;
